var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_367_3822)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 68,
    height: 68,
    rx: 34,
    fill: "#FFD600"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5455,
    y: 11.5455,
    width: 64.9091,
    height: 64.9091,
    rx: 32.4545,
    stroke: "white",
    strokeWidth: 3.09091
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3023 59.1698L53.7272 43.3249H44.3177L46.1128 29.3649L34.0269 46.5712H42.1302L40.3023 59.1698ZM38.9322 49.3136H31.6689C31.0467 49.3136 30.5864 49.0393 30.2883 48.4908C29.9901 47.9423 30.0296 47.4093 30.4067 46.8916L45.9921 24.7098C46.2507 24.3619 46.5767 24.1236 46.9699 23.9949C47.3631 23.8661 47.7626 23.8825 48.1681 24.0438C48.5737 24.1959 48.8847 24.4552 49.1012 24.8217C49.3177 25.1882 49.3961 25.5744 49.3364 25.9803L47.4816 40.5825H56.3168C57.0004 40.5825 57.4783 40.8769 57.7505 41.4655C58.0228 42.0541 57.9442 42.6072 57.515 43.1249L40.3264 63.4163C40.0493 63.7349 39.7107 63.9425 39.3106 64.0393C38.9104 64.1361 38.5299 64.097 38.1689 63.9221C37.7984 63.7565 37.5115 63.5018 37.3082 63.1578C37.105 62.8138 37.0285 62.4331 37.0787 62.0157L38.9322 49.3136Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_367_3822",
    x: -0.818182,
    y: -0.818182,
    width: 89.6364,
    height: 89.6364,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.40909
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.537255 0 0 0 0 0.568627 0 0 0 0 0.611765 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_367_3822"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_367_3822",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/lightning.9fb30aa903653e9e120b88a77f5f7f69.svg";
export { ForwardRef as ReactComponent };